'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'pen-ruler';
var width = 512;
var height = 512;
var aliases = ["pencil-ruler"];
var unicode = 'f5ae';
var svgPathData = ['M58.5 453.5l86.9-24.1c6.6-1.8 12.7-5.4 17.6-10.3L370.1 212 300 141.9 92.9 349.1c-4.9 4.9-8.4 10.9-10.3 17.6L58.5 453.5z', 'M36.4 353.8c4.1-14.6 11.8-27.9 22.6-38.7l294-294C366.4 7.6 384.8 0 404 0s37.6 7.6 51.1 21.2l35.7 35.7C504.4 70.4 512 88.8 512 108s-7.6 37.6-21.2 51.1l-294 294c-10.7 10.7-24.1 18.5-38.7 22.6L30.4 511.1c-8.3 2.3-17.3 0-23.4-6.2s-8.5-15.1-6.2-23.4L36.4 353.8zM386.8 55.1l-52.9 52.9 70.1 70.1 52.9-52.9c4.6-4.6 7.1-10.7 7.1-17.2s-2.6-12.6-7.1-17.2L421.2 55.1C416.6 50.6 410.4 48 404 48s-12.6 2.6-17.2 7.1zM300 141.9L92.9 349.1c-4.9 4.9-8.4 10.9-10.3 17.6l-24.1 86.9 86.9-24.1c6.6-1.8 12.7-5.4 17.6-10.3L370.1 212 300 141.9zm84 318.7l76.7-76.7-29.5-29.5-22.4 22.4c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c13.1-13.1 31.8-31.8 56.2-56.2l.2-.2 69.1 69.1c15.6 15.6 15.6 40.9 0 56.6l-88 88c-15.6 15.6-40.9 15.6-56.6 0l-69.1-69.1 33.9-33.9 63.4 63.4zM114.7 191.4l-33.9 33.9-69.1-69.1c-15.6-15.6-15.6-40.9 0-56.6l88-88c15.6-15.6 40.9-15.6 56.6 0l69.1 69.1-.4 .4 0 0c-24.2 24.2-42.9 42.9-56 56-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l22.4-22.4-29.5-29.5-76.7 76.7 63.4 63.4z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenRuler = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;